import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";
import Button from "@/atomic/atoms/Button";
import { InputMask } from "@react-input/mask";
import { Link } from "react-router-dom";

export default function RegisterView({
  goBack,
  isDisabled,
  errors,
  register,
  handleSubmit,
  watch,
  setValue,
}: PropsView) {
  const watchedValues = watch();
  const isAcceptedTerms = watchedValues.isAcceptedTerms;
  const isAcceptedPrivacy = watchedValues.isAcceptedPrivacy;

  const toggleTerms = () => {
    setValue("isAcceptedTerms", !isAcceptedTerms);
  };

  const togglePrivacy = () => {
    setValue("isAcceptedPrivacy", !isAcceptedPrivacy);
  };

  return (
    <div className="h-full relative">
      <Header
        title="Dados Pessoais"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] h-form">
        <form className="h-full flex flex-col justify-between w-[calc(480px)]" onSubmit={handleSubmit}>
          <div>
            <h2 className="mt-6 text-black text-xl">Vamos começar</h2>
            <div className="flex flex-col justify-center">
              <input
                {...register("name")}
                required
                type="text"
                name="name"
                placeholder="Nome completo"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              {errors.name && (
                <span className="text-red-500 text-xs">{errors.name.message as string}</span>
              )}
              <InputMask
                {...register("document")}
                required
                type="text"
                name="document"
                inputMode="numeric"
                mask="___.___.___-__"
                replacement={{ _: /\d/ }}
                placeholder="CPF"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              {errors.document && (
                <span className="text-red-500 text-xs">{errors.document.message as string}</span>
              )}
              <input
                {...register("email")}
                required
                type="text"
                name="email"
                placeholder="E-mail"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              {errors.email && (
                <span className="text-red-500 text-xs">{errors.email.message as string}</span>
              )}
              <InputMask
                {...register("phone")}
                required
                type="text"
                name="phone"
                inputMode="numeric"
                mask="(__) _____-____"
                replacement={{ _: /\d/ }}
                placeholder="Celular"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              {errors.phone && (
                <span className="text-red-500 text-xs">{errors.phone.message as string}</span>
              )}
              <div className='flex flex-col items-start justify-start mt-4 w-full gap-2'>
                <label className="flex items-center cursor-pointer select-none">
                  <input
                    type="checkbox"
                    checked={isAcceptedTerms}
                    onChange={toggleTerms}
                    className="w-6 h-6 accent-black mr-2 mt-1"
                  />
                  <div className='flex flex-1'>
                    <span className="text-sm text-black">
                      Aceito os <Link to="/terms" className="underline italic text-gray-500" target="_blank">Termos e Condições de Uso</Link>.
                    </span>
                  </div>
                </label>
                {errors.isAcceptedTerms && (
                  <span className="text-red-500 text-xs">{errors.isAcceptedTerms.message as string}</span>
                )}
                <label className="flex cursor-pointer select-none">
                  <input
                    type="checkbox"
                    checked={isAcceptedPrivacy}
                    onChange={togglePrivacy}
                    className="flex w-6 h-6 accent-black mr-2 mt-1"
                  />
                  <div className='flex flex-1'>
                    <span className="text-sm text-black">
                      Estou ciente da <a href="/politicas-de-privacidade.html" className="underline italic text-gray-500" target="_blank" rel="noopener noreferrer">Política de Privacidade</a> e me responsabilizo pela veracidade dos dados.
                    </span>
                  </div>
                </label>
                {errors.isAcceptedPrivacy && (
                  <span className="text-red-500 text-xs">{errors.isAcceptedPrivacy.message as string}</span>
                )}
              </div>
            </div>
          </div>
          <Button
            title="Continuar"
            type="submit"
            isDisabled={isDisabled}
          />
        </form>
      </main>
    </div>
  );
}
